import { LocaleKeys } from '../../../../locale/translation-types'

export enum AccomodationTypeEnum {
  FLAT = 'FLAT',
  HOUSE = 'HOUSE'
}

export const accomodationTypeEnumMapping: Record<AccomodationTypeEnum, LocaleKeys> = {
  [AccomodationTypeEnum.FLAT]: 'accomodation.type.enum.FLAT',
  [AccomodationTypeEnum.HOUSE]: 'accomodation.type.enum.HOUSE'
}
